import type { TweetListResponsePageAllOfThreeContentItemAuthorBasicInfo } from './tweetListResponsePageAllOfThreeContentItemAuthorBasicInfo';
import type { TweetListResponsePageAllOfThreeContentItemAuthorSocial } from './tweetListResponsePageAllOfThreeContentItemAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TweetListResponsePageAllOfThreeContentItemAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TweetListResponsePageAllOfThreeContentItemAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TweetListResponsePageAllOfThreeContentItemAuthorSocial;
};
